module.exports = __webpack_public_path__ + "static/media/signal-3.3eb909df.svg";